import { LEAD_STATUSES } from "../../../constants/lead-statuses.ts"
import {
  DO_NOT_CONTACT_REASON_KEY,
  carriesRetiredState
} from "../../../constants/operational-states.ts"
import { type Lead } from "../../../types/lead.types.ts"

type LeadQuickActionKey = "whatsapp" | "email"

interface LeadQuickActionTargets {
  phone: string | null
  email: string | null
  available: LeadQuickActionKey[]
}

const whatsAppLink = (phone: string) =>
  `https://wa.me/${phone.replace(/\D/g, "")}`

/**
 * The customer's own details, as the list rows read them — a lead carries
 * contact fields of its own, but they describe the enquiry, not the person.
 */
function leadQuickActionTargets(lead: Lead): LeadQuickActionTargets {
  const contact = lead?.customer || lead?.temporary_customer
  const phone = contact?.phone?.trim() || null
  const email = contact?.email?.trim() || null

  // Both spellings: until the backend's crm/0037 migration runs, a lead can
  // still refuse contact through the retired overlay while its status reads
  // NEW — and re-offering WhatsApp to that customer is the one failure here
  // we cannot take back.
  const doNotContact =
    lead?.status === LEAD_STATUSES.DO_NOT_CONTACT ||
    carriesRetiredState(lead?.operational_states, DO_NOT_CONTACT_REASON_KEY)
  if (doNotContact) return { phone, email, available: [] }

  const available: LeadQuickActionKey[] = []
  if (phone) available.push("whatsapp")
  if (email) available.push("email")

  return { phone, email, available }
}

export {
  leadQuickActionTargets,
  whatsAppLink,
  type LeadQuickActionKey,
  type LeadQuickActionTargets
}
